import { PublicClientApplication } from '@azure/msal-browser';

// Options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications
const settings = {
  auth: {
    clientId:"a027e8dc-afc0-4f4a-b635-8e0efbda386b",
    authority: "https://login.microsoftonline.com/98e9ba89-e1a1-4e38-9007-8bdabc25de1d",
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: true,
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    navigateFrameWait: 500,  // Increased from 0 to 500ms to handle production network latency
    /* eslint-disable no-console */
    logger: {
      error: console.error,
      errorPii: console.error,
      info: console.log,
      infoPii: console.log,
      verbose: console.log,
      verbosePii: console.log,
      warning: console.warn,
      warningPii: console.warn,
    },
  },
};

export const msalApp = new PublicClientApplication(settings);

export async function handleLogin () {
  const loginRequest = {
    scopes: ['email', 'openid', 'profile'],
  };

  try {
    const response = await msalApp.ssoSilent(loginRequest);
    const accessToken = response.accessToken;

    // Call the Microsoft Graph API to get user information
    const graphResponse = await fetch('https://graph.microsoft.com/v1.0/me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const userData = await graphResponse.json();
    return userData

    // Access user information from the 'userData' object
  } catch (error) {
    console.error('Silent login failed', error);
    return null;
    }
};

// Enhanced auto-login function that tries silent auth first, then automatic popup
export async function handleAutoLogin() {
  const loginRequest = {
    scopes: ['email', 'openid', 'profile'],
  };

  try {
    // First, try silent authentication
    console.log('Attempting silent authentication...');
    const response = await msalApp.ssoSilent(loginRequest);
    const accessToken = response.accessToken;

    // Call the Microsoft Graph API to get user information
    const graphResponse = await fetch('https://graph.microsoft.com/v1.0/me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const userData = await graphResponse.json();
    console.log('Silent authentication successful');
    return { success: true, userData, method: 'silent' };

  } catch (silentError) {
    console.log('Silent authentication failed');
    
    // Check if this is a user cancellation or network error that should not trigger auto-login
    if (silentError.errorCode === 'user_cancelled' || 
        silentError.errorCode === 'network_error' ||
        silentError.errorCode === 'monitor_window_timeout' ||
        silentError.message?.includes('user_cancelled')) {
      return { success: false, error: 'Authentication cancelled or network error', requiresManualLogin: true };
    }
    
    // Only attempt popup for token expiration or consent required
    if (silentError.errorCode === 'consent_required' || 
        silentError.errorCode === 'interaction_required' ||
        silentError.errorCode === 'login_required') {
      try {
        // Attempt automatic popup login
        const popupResponse = await msalApp.acquireTokenPopup(loginRequest);
        const accessToken = popupResponse.accessToken;

        // Call the Microsoft Graph API to get user information
        const graphResponse = await fetch('https://graph.microsoft.com/v1.0/me', {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        const userData = await graphResponse.json();
        console.log('Automatic popup authentication successful');
        return { success: true, userData, method: 'popup' };

      } catch (popupError) {
        console.error('Popup authentication failed');
        
        // Check if user cancelled the popup
        if (popupError.errorCode === 'user_cancelled' || 
            popupError.message?.includes('user_cancelled')) {
          return { success: false, error: 'Authentication cancelled', requiresManualLogin: true, userCancelled: true };
        }
        
        // For other errors, still allow manual login
        return { success: false, error: 'Authentication failed', requiresManualLogin: true };
      }
    }
    
    // For other errors, require manual login without popup attempt
    return { success: false, error: 'Authentication required', requiresManualLogin: true };
  }
}

export async function handleLoginButton () {
  const loginRequest = {
    scopes: ['email', 'openid', 'profile'],
  };

  try {
    const response = await msalApp.acquireTokenPopup(loginRequest);
    const accessToken = response.accessToken;

    // Call the Microsoft Graph API to get user information
    const graphResponse = await fetch('https://graph.microsoft.com/v1.0/me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const userData = await graphResponse.json();
    return userData

    // Access user information from the 'userData' object
  } catch (error) {
    console.error('Login failed', error);
    window.alert('Login Failed: ' + error.message);
    }
};

export async function handleLogout() {
  try {
    await msalApp.logoutPopup({
      postLogoutRedirectUri: window.location.origin,
      mainWindowRedirectUri: window.location.origin
    });
    
    // Clear any additional session data if needed
    sessionStorage.clear();
    
    // Reload the page to reset the application state
    window.location.reload();
  } catch (error) {
    console.error('Logout failed', error);
    // Fallback: clear session and reload
    sessionStorage.clear();
    window.location.reload();
  }
};
